import React from 'react';
import './loader.css'; 
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Loader = () => {
  return (
    <div>
 <div className="loader-overlay">
     <div> 
     <DotLottieReact
      src="https://lottie.host/2c2af277-1dd7-4fbc-8c1c-3dd7aa3f70de/2X9YvgmdRJ.lottie"
      loop
      autoplay
      style={{ height: '120px', width: '250px' }}
      />
       <div style={{display:'flex', justifyContent:"center", position:"relative", bottom:'25px',marginLeft:'15px'}}> 
       <p className='txt_loading'>Loading ...</p>
       </div>
    
     </div>

    </div>
   
    </div>
  )
}

export default Loader
